/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { SkumapTemplateAssociationsResultMap } from '../../models/skumap-template-associations-result-map';

export interface SkumapTemplatesTemplateIdGet$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
}

export function skumapTemplatesTemplateIdGet(http: HttpClient, rootUrl: string, params: SkumapTemplatesTemplateIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap>> {
  const rb = new RequestBuilder(rootUrl, skumapTemplatesTemplateIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & SkumapTemplateAssociationsResultMap>;
    })
  );
}

skumapTemplatesTemplateIdGet.PATH = '/skumap/templates/{templateId}';
